<p-dialog appDialogoPadrao="pi pi-book" descricao="Especialidades ligadas a esta formação." [(visible)]="showDialog" [style]="{ width: '800px', maxWidth: '95vw' }" header="Especialidades Relacionadas" (onHide)="hide()">
    <div class="dialog-content">
        <p-table
            [value]="itens()"
            [paginator]="true"
            [rows]="10"
            [rowsPerPageOptions]="[5, 10, 20]"
            [tableStyle]="{ 'min-width': '100%' }"
            styleClass="p-datatable-gridlines"
            [responsiveLayout]="'scroll'"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 50%">ESPECIALIDADE</th>
                    <th style="width: 50%">ÁREA DE ATUAÇÃO</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{ row?.especialidade }}</td>
                    <td>{{ row?.areaAtuacao }}</td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="2" style="text-align: center">
                        <div class="table-empty-state">
                            <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                            <p class="table-empty-state-title">Nenhum registro encontrado.</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Fechar" icon="pi pi-times" (onClick)="hide()" severity="secondary" />
    </ng-template>
</p-dialog>
